import type { Option } from '@ksyos/design-system';
import { nonNullable } from '@common/utils/nonNullableTypeUtils';
import { getSelectedLanguage } from '@frontend/translate';
import type { IService } from '../components/interfaces/service';

export type OptionWithinGroup = Option & { isGroupHeader?: boolean; isGroupOption?: boolean };

export function getServicesGroupedByEpisodeCategoriesOptions(services: IService[]) {
    const translate = getSelectedLanguage();
    const episodeIds = [...new Set<string>(services.map((service: IService) => service.episodeCategory.id))];
    const episodes = episodeIds
        .map(
            (id: string) =>
                nonNullable(services.find((service: IService) => service.episodeCategory.id === id)).episodeCategory
        )
        .sort((a, b) => translate.episodeCategoryEnum[a.name].localeCompare(translate.episodeCategoryEnum[b.name]));
    const options: OptionWithinGroup[] = [];

    for (const episode of episodes) {
        options.push({
            isGroupHeader: true,
            label: translate.episodeCategoryEnum[episode.name],
            value: episode.id,
        });

        const filteredServices = services
            .filter((service: IService) => service.episodeCategory.id === episode.id)
            .sort((a, b) => a.name.localeCompare(b.name));

        filteredServices.map((service: IService) =>
            options.push({
                isGroupOption: true,
                label: service.name,
                value: service.id,
            })
        );
    }

    return options;
}
